import { render } from "./RegisterModalSmall.vue?vue&type=template&id=5885fc31&scoped=true"
import script from "./RegisterModalSmall.vue?vue&type=script&lang=js"
export * from "./RegisterModalSmall.vue?vue&type=script&lang=js"

import "./RegisterModalSmall.vue?vue&type=style&index=0&id=5885fc31&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5885fc31"]])

export default __exports__